import * as z from "zod";

export const updateLocationShippingName = {
  name: "updateLocationShippingName" as const,
  input: z.object({ locationId: z.string(), shippingName: z.string() }),
  output: z.union([
    z.object({ success: z.literal(true) }),
    z.object({ success: z.literal(false), error: z.string() }),
  ]),
};
